export default "__VITE_ASSET__a642faea__"